export enum ADDRESS_SUMMARY_TEST_ID {
  ROOT = 'address-summary',
  TITLE = 'address-summary-title',
  SUMMARY = 'address-summary-summary'
}

export enum SECTION_WRAPPER_TEST_ID {
  ROOT = 'section',
  CONTAINER = 'section-container',
  INNER_SECTION = 'section-inner-section',
  ANCHOR = 'section-anchor'
}

export enum BUTTON_TEST_ID {
  PRIMARY = 'primary-button',
  SECONDARY = 'secondary-button',
  QUATERNARY = 'quaternary-button',
  TERTIARY = 'tertiary-button',
  GENERIC = 'generic-button',
  SWITCH_ADDRESS_INPUTS = 'switch-address-inputs-button',
  BUTTON_CHILDREN = 'children',
  BUTTON_ICON = 'icon'
}

export const GLOBAL_FOOTER = 'global-footer';

export const ACCORDION_LIST = 'accordion-list';
export const ACCORDION_DROPDOWN_TEST_ID = 'accordion-dropdown';

/** copied from ../constants/testIds.ts */

export const GLOBAL_BACK_TO_TOP_PORTAL = 'back-to-top-portal';
export const GLOBAL_BACK_TO_TOP_TRIGGER = 'back-to-top-trigger';

export const ALERT = 'alert';
export const ALERT_DISMISS_BUTTON = `${ALERT}-dismiss-button`;
export const ALERT_LINK = `${ALERT}-link`;

export const LOADING_BUTTON_PROGRESS = 'button-progress';

export const APPLY_CODE = {
  ROOT: 'apply-code',
  LABEL: 'apply-code-label',
  INPUT: 'apply-code-input',
  BUTTON: 'apply-code-button',
  DESCRIPTION: 'apply-code-description'
};

export const PICTURE = {
  ROOT: 'picture__root',
  IMG: 'picture__the-image'
};

export const ACTION_STRIP = {
  ROOT: 'action-strip__root',
  TITLE: 'action-strip__title'
};

export const ACTION_TILES = {
  ROOT: 'action-tile__root',
  OUTER_WRAPPER: 'action-tile__outer-wrapper',
  BUTTON: 'action-tile__button'
};

export const CALLOUT = {
  ROOT: 'callout__root',
  ICON: 'callout__icon',
  TITLE: 'callout__title',
  DESCRIPTION: 'callout__description'
};

export const TILE_HEADER = {
  TAG: 'tile-header__tag',
  AVC_ID_LABEL: 'tile-header__avc-id-label'
};

export const DATA_BALANCE = {
  ROOT: 'data-balance__root',
  RHS_LABEL: 'data-balance__rhs-label'
};

export enum SECTION_INFO_TEST_ID {
  section = 'section-info',
  heading = 'section-info--heading',
  bodyContent = 'section-info--body',
  primaryButton = 'section-info--primary-button',
  secondaryButton = 'section-info--secondary-button',
  secondaryButtonLink = 'secondary-button',
  idvIntro = 'idv-intro'
}

export const NBN_AGENT_TEST_IDS = {
  ALL_PAGES_TOP_LAYOUT: 'top-layout',

  // customer details
  CUSTOMER_DETAILS_FORM: 'customer-details-form',
  CUSTOMER_DETAILS_PAGE: 'customer-details-page',
  CUSTOMER_DETAILS_SUBMIT_BTN: 'customer-details-submit',
  CUSTOMER_DETAILS_BACK_BTN: 'customer-details-back',

  // mobile capture
  MOBILE_CAPTURE_FORM: 'mobile-capture-form',
  MOBILE_CAPTURE_PAGE: 'mobile-capture-page',
  MOBILE_CAPTURE_SUBMIT_BTN: 'mobile-capture-submit',
  MOBILE_CAPTURE_BACK_BTN: 'mobile-capture-back',

  // processing payment
  PROCESSING_PAYMENT: 'processing-payment-page',
  STATUS_SECTION: 'status-section',
  PAYMENT_IN_PROGRESS: 'payment-in-progress',
  PAYMENT_TIMED_OUT: 'payment-timed-out',
  PAYMENT_UNSUCCESSFUL: 'payment-unsuccessful',

  // mobile verify form
  MOBILE_VERIFY_FORM: 'mobile-verify-form',
  MOBILE_VERIFY_PAGE: 'mobile-verify-page',
  MOBILE_VERIFY_SUBMIT_BTN: 'mobile-verify-submit',
  MOBILE_VERIFY_BACK_BTN: 'mobile-verify-back',

  // terms & conditions
  TERMS_CONDITIONS_FORM: 'terms-conditions-form',
  TERMS_CONDITIONS_PAGE: 'terms-conditions-page',
  TERMS_CONDITIONS_ACKNOWLEDGEMENT: 'terms-conditions-acknowledgement',
  TERMS_CONDITIONS_SERVER_ERROR: 'terms-conditions-server-error',
  TERMS_CONDITIONS_SUBMIT_BTN: 'terms-conditions-submit',
  TERMS_CONDITIONS_BACK_BTN: 'terms-conditions-back',

  // service detected
  SERVICE_DETECTED_PAGE: 'service-detected-page',

  // modem, sim and ncd delivery
  MODEM_DELIVERY_PAGE: 'modem-delivery-page',

  // order confirmation
  ORDER_CONFIRMATION_PAGE_NO_BOOKING_DEFAULT: 'order-confirmation-details',
  ORDER_CONFIRMATION_PAGE_NO_BOOKING_HFC: 'order-confirmation-hfc',
  ORDER_CONFIRMATION_PAGE_NO_BOOKING_CONNECT_OUTSTANDING: 'order-confirmation-connect-outstanding',
  ORDER_CONFIRMATION_PAGE_BOOKING_NEW_STACK: 'order-confirmation-appointment-details',
  ORDER_CONFIRMATION_PAGE_APPOINTMENT_BOOKING_ISSUE: 'order-confirmation-appointment-booking-issue',
  ORDER_CONFIRMATION_PAGE_APPOINTMENT_ARRANGEMENT_REQUIRED: 'order-confirmation-appointment-arrangement-required'
};

export const PAYMENT_TEST_IDS = {
  // customer payment
  CUSTOMER_PAYMENT_LOADING: 'customer-payment-loading',

  CUSTOMER_PAYMENT_PAGE: 'customer-payment-page',
  CUSTOMER_PAYMENT_FORM: 'customer-payment-form',
  CUSTOMER_PAYMENT_RESULT: 'customer-payment-result',
  CUSTOMER_PAYMENT_SUBMIT_BTN: 'customer-payment-submit'
};

export enum PAYMENT_METHOD_CARD_TEST_IDS {
  ROOT = 'payment-method-root',
  HEADING = 'payment-method-card-heading',
  LINK = 'payment-method-link',
  ICON = 'payment-method-icon'
}

export const ORDER_SUMMARY_TEST_IDS = {
  ORDER_SUMMARY_BUTTONS_WRAPPER: 'order-summary-buttons-wrapper',
  STICKY_BUTTONS_WRAPPER: 'sticky-buttons-wrapper'
};
